import { useQuery } from "@tanstack/react-query";
import { gqlRequest } from "@/api/graphql/request";
import { DASHBOARD_ACTIVITY } from "@/api/graphql/operations/dashboard";

interface ActivityItem {
  action: string;
  detail: string;
  time: string;
  iconKey: string;
}

export function useActivity() {
  return useQuery({
    queryKey: ["dashboard", "activity"],
    queryFn: () =>
      gqlRequest<{ dashboardActivity: ActivityItem[] }>(
        DASHBOARD_ACTIVITY,
      ).then((d) => d.dashboardActivity),
    staleTime: 60_000,
  });
}
